import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss']
})
export class AdminComponent implements OnInit {

  @ViewChild('adminFrame') adminFrame!: ElementRef<HTMLIFrameElement>;

  // ─── Auth ─────────────────────────────────────────────────────────────────
  isLoggedIn   = false;
  loginUsername = '';
  loginPassword = '';
  loginError   = '';
  showPassword = false;

  // ─── Admin iframe ─────────────────────────────────────────────────────────
  adminUrl: SafeResourceUrl;
  adminOffline = false;
  private readonly ADMIN_SERVER = 'http://localhost:3002';

  // ─── Toast ────────────────────────────────────────────────────────────────
  toast: { message: string; type: 'success' | 'error' } | null = null;

  constructor(private sanitizer: DomSanitizer) {
    this.adminUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.ADMIN_SERVER);
  }

  ngOnInit(): void {
    const saved = sessionStorage.getItem('admin_logged_in');
    if (saved === 'true') {
      this.isLoggedIn = true;
      this.checkServer();
    }
  }

  // ─── Auth ─────────────────────────────────────────────────────────────────
  login() {
    if (this.loginUsername === 'admin' && this.loginPassword === 'admin') {
      this.isLoggedIn = true;
      this.loginError = '';
      sessionStorage.setItem('admin_logged_in', 'true');
      this.checkServer();
    } else {
      this.loginError = 'Invalid credentials. Use admin / admin';
    }
  }

  logout() {
    this.isLoggedIn = false;
    sessionStorage.removeItem('admin_logged_in');
    this.loginUsername = '';
    this.loginPassword = '';
    this.adminOffline  = false;
  }

  // ─── iframe helpers ───────────────────────────────────────────────────────
  onFrameLoad()  { this.adminOffline = false; }
  onFrameError() { this.adminOffline = true;  }

  reloadFrame() {
    this.adminOffline = false;
    // Re-assign the safe URL to force iframe reload
    this.adminUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      this.ADMIN_SERVER + '?t=' + Date.now()
    );
    this.showToast('Reloading admin panel…', 'success');
  }

  checkServer() {
    fetch(this.ADMIN_SERVER, { method: 'HEAD', mode: 'no-cors' })
      .then(() => { this.adminOffline = false; })
      .catch(() => { this.adminOffline = true;  });
  }

  // ─── Toast ────────────────────────────────────────────────────────────────
  showToast(message: string, type: 'success' | 'error') {
    this.toast = { message, type };
    setTimeout(() => this.toast = null, 3000);
  }
}
